// const BookingPolicy = () => (
//   <div className="space-y-5">
//     <p>
//       To confirm your trek booking, an advance payment is required to arrange
//       permits, guides, accommodations, and logistics.
//     </p>

//     <ul className="list-disc pl-5 space-y-2">
//       <li>30% deposit required to secure your booking</li>
//       <li>Remaining balance payable upon arrival in Kathmandu</li>
//       <li>Bookings are confirmed only after payment receipt</li>
//       <li>Last-minute bookings depend on permit and guide availability</li>
//     </ul>

//     <p className="font-medium text-gray-900">
//       All bookings are handled transparently with no hidden charges.
//     </p>
//   </div>
// );

// export default BookingPolicy;

import { Info } from "lucide-react";
const BookingPolicy = () => (
  <div className="space-y-6 text-gray-700 leading-relaxed">
    <p>
      To confirm your trek booking, an advance payment is required to arrange
      permits, guides, accommodations, and logistical preparations in Nepal.
    </p>

    <ul className="list-disc pl-5 space-y-2">
      <li>30% deposit required to secure your booking</li>
      <li>Remaining balance payable upon arrival in Kathmandu</li>
      <li>Bookings are confirmed only after payment receipt</li>
      <li>Last-minute bookings depend on permit and guide availability</li>
    </ul>

    <div className="flex gap-3 bg-blue-50 border border-blue-200 p-4 rounded-xl">
      <Info className="text-blue-600 mt-1" />
      <p className="text-sm text-blue-800">
        All prices are transparent with no hidden charges. Government taxes,
        permits, and guide fees are included unless stated otherwise.
      </p>
    </div>

    <p className="text-sm text-gray-600">
      We strongly recommend booking early during peak trekking seasons (Spring &
      Autumn) to ensure availability of experienced guides and accommodations.
    </p>
  </div>
);

export default BookingPolicy;
